
export const useColors = () => {
    const colors = [
        {
            hex: "#0B2F9F"
        },
        {
            hex: "#7A1CAC"
        },
        {
            hex: "#FFDC7F"
        },
        {
            hex: "#D8A25E"
        },
        {
            hex: "#7695FF"
        },
        {
            hex: "#FFBE98"
        }
    ];
    return {
        colors: colors
    };
}
